













import { ACONEX_AUTH_WINDOW_MESSAGE_NAME } from '@/services/aconex.service';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class AconexCallback extends Vue {
  // * PROPS

  // * DATA

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
  private created() {
    const code = this.$route.query.code;
    if (code) {
      console.log('aconex callback: sending code to parent', code);
      window.opener.postMessage({ name: ACONEX_AUTH_WINDOW_MESSAGE_NAME, data: { code } }, window.location.origin);
      // Nope, don't close the popup. The opener will close it when they're done processing the message
      // window.close();
    }
  }
}
